export { SiteMapPage as default } from '@/components/enpages/SiteMap'
